/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Passkey_Setup_SpeedInputs */



/**
* | output |
* | --- |
* | "Logging in with a passkey is much faster — just one click instead of waiting for an email." |
*
* @param {Auth_Passkey_Setup_SpeedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const auth_passkey_setup_speed = /** @type {((inputs?: Auth_Passkey_Setup_SpeedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Passkey_Setup_SpeedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Die Anmeldung mit einem Passkey ist viel schneller — nur ein Klick statt auf eine E-Mail zu warten.")
	return /** @type {LocalizedString} */ ("Logging in with a passkey is much faster — just one click instead of waiting for an email.")
});